
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import { Options, setup, Vue } from 'vue-class-component';
import { useStore } from 'vuex';
import { _ROUTER_NAME } from '@/enums';

@Options({
	name: 'PersonalReport',
	components: {
		DaIcon,
	},
	computed: {
		_ROUTER_NAME() {
			return _ROUTER_NAME;
		},
	},
})
export default class PersonalReport extends Vue {
	openFilter = 0;

	setup = setup(() => {
		const store = useStore();
		return {
			store,
			enable_weekly_report:
				store.state?.profile?.current_org?.enable_weekly_report,
		};
	});

	get tabs() {
		const tabsData: any[] = [
			{
				id: 0,
				name: 'Báo cáo buổi học',
				icon: 'das--book',
				link: _ROUTER_NAME.REPORT_LESSON,
			},
		];

		if (this.setup.enable_weekly_report) {
			tabsData.push({
				id: 1,
				name: 'Báo cáo tuần',
				icon: 'das--calender',
				link: _ROUTER_NAME.REPORT_WEEK_CLASS,
			});
		}

		tabsData.push({
			id: 2,
			name: 'Báo cáo tháng',
			icon: 'das--statics',
			link: _ROUTER_NAME.REPORT_PLANS_CLASS,
		});

		return tabsData;
	}

	triggerFilter() {
		this.openFilter = Date.now();
	}
}
